/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { html } from '@codemirror/lang-html';
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { MailSend02Icon } from '@hugeicons-pro/core-stroke-rounded';
import { styled } from '@mui/material/styles';
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Box, IconButton } from '@mui/material';
import MergeTagsDropdown from './MergeTagsDropdown';
// @ts-ignore
import { html as beautifyHtml } from 'js-beautify';
import debounce from 'lodash.debounce';
import { checkEventPermission } from 'src/common/utility/utility';
import { SEND_TEST_EMAIL } from 'src/constants/constant';

interface TemplateEditorProps {
  onHtmlChange: (html: string) => void;
  initialHtml?: string;
  onImageUpload?: () => void;
  editorRef?: React.MutableRefObject<any>;
  isEditPage?: boolean;
  onSendTestEmail?: () => void;
}

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
  [`& .${tooltipClasses.arrow}`]: {
    display: 'none',
  },
}));

function CustomEditor({
  onHtmlChange,
  initialHtml,
  onImageUpload,
  editorRef: externalEditorRef,
  onSendTestEmail,
  isEditPage
}: TemplateEditorProps): JSX.Element {
  const internalEditorRef = useRef(null);
  const editorRef = externalEditorRef ?? internalEditorRef;

  const [viewMode, setViewMode] = useState<'preview' | 'code'>(isEditPage ? 'preview' : 'code');
  const [code, setCode] = useState<string>('');

  const iframeRef = useRef<HTMLIFrameElement>(null);
  const isInsertingTagRef = useRef(false);

  // Initialize code with initialHtml when component mounts or when initialHtml changes
  useEffect(() => {
    if (initialHtml != '' && initialHtml != undefined) {
      //@ts-ignore
      setCode(initialHtml);
    }
  }, [initialHtml]);


// Helper function to get full HTML document with updated body content
const getFullHtmlWithUpdatedBody = (newBodyContent: string): string => {
  const hasHtmlStructure = /<(!DOCTYPE|html|head|body)/i.test(code);
  
  if (!hasHtmlStructure) {
    // If original code doesn't have HTML structure, return just the content
    return newBodyContent;
  }

  // Replace the body content while preserving everything else
  return code.replace(
    /(<body[^>]*>)([\s\S]*?)(<\/body>)/i,
    `$1${newBodyContent}$3`
  );
};

useEffect(() => {
  if (viewMode === 'preview' && iframeRef.current) {
    const doc = iframeRef.current.contentDocument;
    const win = iframeRef.current.contentWindow;
    if (!doc || !win) return;

    const style = `
      <style>
        body {
          font-family: Arial, sans-serif;
          padding: 16px;
          outline: none;
        }
        .brace {
          font-weight: bold;
          user-select: none;
          font-family: monospace;
          background: linear-gradient(90deg, 
            #007bff 0ch, #007bff 2ch, 
            #000 2ch, #000 calc(100% - 2ch), 
            #007bff calc(100% - 2ch), #007bff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        
        @supports not (-webkit-background-clip: text) {
          .brace {
            color: #000;
          }
        }
      </style>
    `;

    const hasHtmlStructure = /<(!DOCTYPE|html|head|body)/i.test(code);
    
    if (!doc.body || doc.body.innerHTML === '') {
       doc.open();

      if (hasHtmlStructure) {
        const htmlWithStyles = code.replace(
          /(<head[^>]*>)/i,
          `$1${style}`
        ).replace(
          /(<body[^>]*)/i,
          `$1 contenteditable="true"`
        );
        (doc as any).write(htmlWithStyles);
      } else {
        (doc as any).write(`<html><head>${style}</head><body contenteditable="true">${code}</body></html>`);
      }

       doc.close();

    }
    // Remove the automatic content sync that was causing issues

    const body = doc.body;
    if (!body) return;
    // ✅ Only update <img> src values instead of replacing whole body
    const newDoc = document.createElement("html");
    newDoc.innerHTML = code;
    const newImages = newDoc.querySelectorAll("img");
    const currentImages = body.querySelectorAll("img");

    newImages.forEach((newImg, idx) => {
      const currentImg = currentImages[idx];
      if (currentImg && currentImg.src !== newImg.src) {
        currentImg.src = newImg.src;
      }
    });

    // Only listen to user input changes, not programmatic changes
    const handleInput = (): void => {
      if (!isInsertingTagRef.current) {
        const newBodyContent = body.innerHTML;
        const fullHtml = getFullHtmlWithUpdatedBody(newBodyContent);
        setCode(fullHtml);
        onHtmlChange(fullHtml);
      }
    };
    
    body.addEventListener('input', handleInput);

    return () => {
      body.removeEventListener('input', handleInput);
    };
  }
}, [viewMode, code, onHtmlChange]);

const insertMergeTagInIframe = (tag: string): void => {
  const iframeDoc = iframeRef.current?.contentDocument;
  const iframeWin = iframeRef.current?.contentWindow;
  if (!iframeDoc || !iframeWin) return;

  const body = iframeDoc.body;
  if (!body) return;

  isInsertingTagRef.current = true;
  body.focus();

  const span = iframeDoc.createElement('span');
  span.className = 'brace';
  span.contentEditable = 'false';

  const inner = tag.replace(/[{}]/g, '').trim();
  span.textContent = `{{${inner}}}`;

  const sel = iframeWin.getSelection();
  let range = sel?.rangeCount ? sel.getRangeAt(0) : null;

  if (!range || !body.contains(range.startContainer)) {
    range = iframeDoc.createRange();
    range.selectNodeContents(body);
    range.collapse(false);
    sel?.removeAllRanges();
    sel?.addRange(range);
  }

  try {
    range.deleteContents();
    range.insertNode(span);

    const cursor = iframeDoc.createRange();
    cursor.setStartAfter(span);
    cursor.collapse(true);
    sel?.removeAllRanges();
    sel?.addRange(cursor);

    requestAnimationFrame(() => {
      const newBodyContent = body.innerHTML;
      const fullHtml = getFullHtmlWithUpdatedBody(newBodyContent);
      setCode(fullHtml);
      onHtmlChange(fullHtml);
      isInsertingTagRef.current = false;
      body.focus();
    });
  } catch (err) {
    console.error('Error inserting merge tag:', err);
    isInsertingTagRef.current = false;
  }
};
  const handleUploadImages = (): void => {
    if (onImageUpload) {
      onImageUpload();
    }
  };

  const handleSendTestEmail = (): void => {
    if (onSendTestEmail) {
      onSendTestEmail();
    }  
  };


  
  const insertAtCursor = (text: string): void => {
    const view = editorRef.current?.view;
    if (!view) return;

    const { from } = view.state.selection.main;
    const to = from + text.length;

    view.dispatch({
      changes: { from, insert: text },
      selection: { anchor: to },
    });

    view.focus();
  };

  useEffect(() => {
    const view = editorRef.current?.view;

    const handlePaste = (event: ClipboardEvent): void => {
      const pastedText = event.clipboardData?.getData('text/plain');
      if (pastedText != null && /<\/?[a-z][\s\S]*>/i.test(pastedText)) {
        event.preventDefault();
        const beautified = beautifyHtml(pastedText, {
          indent_size: 2,
          wrap_line_length: 120,
        });
        insertAtCursor(beautified);
      }
    };

    if (view?.dom) {
      view.dom.addEventListener('paste', handlePaste);
    }

    return () => {
      if (view?.dom) {
        view.dom.removeEventListener('paste', handlePaste);
      }
    };
  }, [editorRef]);

  const debouncedSetCode = useRef(
    debounce((val: string) => {
      setCode(val);
      onHtmlChange(val);
    }, 200),
  ).current;

  console.log(isEditPage);

  return (
    <React.Fragment>
      <div style={{ fontFamily: 'Manrope, sans-serif' }}>
        {/* Unified Toolbar Line */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '8px',
            flexWrap: 'wrap',
            gap: '10px',
            fontFamily: 'Manrope, sans-serif',
          }}
        >
          {/* Left Section: Toggle + Merge Tags + Send Test */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              flexWrap: 'wrap',
            }}
          >
            {/* Toggle Buttons */}
            <div
              style={{
                display: 'flex',
                background: '#f5f5f5',
                borderRadius: '999px',
                width: '150px'
              }}
            >
              <button
                onClick={() => setViewMode('preview')}
                type='button'
                style={{
                  flex: 1,
                  padding: '8px 0',
                  border: 'none',
                  borderRadius: '999px',
                  color:'#3a3a3a',
                  backgroundColor:
                    viewMode === 'preview' ? '#fff' : ' #F5F5F5',
                  fontWeight: viewMode === 'preview' ? 600 : 400,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow:
                    viewMode === 'preview'
                      ? '0 1px 3px rgba(0,0,0,0.1)'
                      : 'none',
                }}
              >
                Preview
              </button>
              <button
                onClick={() => setViewMode('code')}
                type='button'
                style={{
                  flex: 1,
                  padding: '8px 0',
                  border: 'none',
                  color:'#3a3a3a',
                  borderRadius: '999px',
                  backgroundColor: viewMode === 'code' ? '#fff' : ' #F5F5F5',
                  fontWeight: viewMode === 'code' ? 600 : 400,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow:
                    viewMode === 'code' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                }}
              >
                Code
              </button>
            </div>
             {/* Send Test Email */}
             {(isEditPage
  ? checkEventPermission("TEMPLATE_UPDATE")
  : checkEventPermission("TEMPLATE_ADD")) && (
  <div className="icon-hover-container">
    <BootstrapTooltip title={SEND_TEST_EMAIL}>
      <IconButton onClick={handleSendTestEmail}>
        <HugeiconsIcon
          icon={MailSend02Icon}
          size={24}
          strokeWidth={0.2}
          color="#3a3a3a"
        />
      </IconButton>
    </BootstrapTooltip>
  </div>
)}

<MergeTagsDropdown insertAtCursor={viewMode === 'code' ? insertAtCursor : insertMergeTagInIframe} viewMode={viewMode} />

            {viewMode === 'code' && (
              <>
                <Box
                  onClick={() => {
                    const beautified = beautifyHtml(code, {
                      indent_size: 2,
                      wrap_line_length: 120,
                    });
                    setCode(beautified);
                  }}
                  sx={{
                    color: '#3a3a3a',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    '&:hover': {
                      backgroundColor: '#fafafa',
                    },
                  }}
                  id='format-code'
                >
                  Format Code
                </Box>
              </>
            )}
          </div>

          {(isEditPage
            ? checkEventPermission("TEMPLATE_UPDATE")
            : checkEventPermission("TEMPLATE_ADD")) && 
            
          <Box
            onClick={handleUploadImages}
            sx={{              
              color: '#7869E',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 600,
              whiteSpace: 'nowrap',
              padding: '4px 8px',
              borderRadius: '4px',
              '&:hover': {
                backgroundColor: '#fafafa',
              },
            }}
            id='upload-images'
          >
            {'Upload Images ->'}
          </Box>
         
          }
        </div>

        {/* Content Based on View */}
        {viewMode === 'code' ? (
          <div
            style={{
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              overflow: 'hidden',
            }}
          >
            <CodeMirror
              value={code}
              height="70vh"
              // eslint-disable-next-line @typescript-eslint/no-unsafe-call
              extensions={[html()]}
              onChange={(value) => debouncedSetCode(value)}
              placeholder="Type your HTML here..."
              theme="light"
              ref={editorRef}
              style={{ fontSize: '14px' }}
            />
          </div>
        ) : (
          <div
            style={{
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              overflow: 'hidden',
              height: '70vh',
            }}
          >
            <iframe
              ref={iframeRef}
              title="Live Preview"
              style={{ width: '100%', height: '100%', border: 'none' }}
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default CustomEditor;